import { definePreset } from '@primeuix/styled';
import Aura from '@primeuix/themes/aura';

const EtPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        highlight: {
          background: '{primary.50}',
          color: '{primary.700}'
        }
      },
      dark: {
        highlight: {
          background: '{primary.200}',
          color: '{primary.900}'
        }
      }
    }
  },
  components: {
    select: {
      colorScheme: {
        light: {
          root: {
            placeholderColor: '{surface.700}'
          },
          dropdown: {
            color: '{surface.700}'
          }
        },
        dark: {
          root: {
            placeholderColor: '{primary.50}'
          },
          dropdown: {
            color: '{primary.50}'
          },
          optionGroup: {
            color: '{primary.50}'
          }
        }
      }
    }
  }
});
export default EtPreset;
